export * from './show-beneficiary.component';
